import React, { useState } from "react";
import {
  Box,
  Flex,
  Icon,
  Tab,
  Tabs,
  TabList,
  TabPanels,
  TabPanel,
  Text,
  Button,
  Input,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
} from "@chakra-ui/react";
import { MessageSquare, Headset, Bell } from "lucide-react";
import BackgroundImage from "../../../assets/img/longarrow.jpg";
import Chat from "../Chat";
import ContactLogManagement from "../ContactLogManagement";
import NotificationManagement from "../Notifications";

// Custom Tab Component
const CustomTab = ({ icon, label }) => (
  <Tab
    fontSize="sm"
    color="gray.500"
    _selected={{
      color: "white",
      bg: "transparent",
      backgroundImage: `url(${BackgroundImage})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
    }}
  >
    <Icon as={icon} mr={2} />
    {label}
  </Tab>
);

const Communications = () => {
  return (
    <Box w="100%" p={4} mt={"70px"} ml={"9px"}>

      <Tabs variant="enclosed">
        <TabList>
          <CustomTab icon={MessageSquare} label="Chat Messages" />
          <CustomTab icon={Headset} label="Call Logs" />
          <CustomTab icon={Bell} label="Send Notifications" />
        </TabList>

        <TabPanels>
          <TabPanel>
            <Chat />
          </TabPanel>
          <TabPanel>
            <ContactLogManagement />
          </TabPanel>

          <TabPanel>
            <NotificationManagement />
          </TabPanel>

        </TabPanels>
      </Tabs>
    </Box>
  );
};


export default Communications;
